<ngx-loading-bar color="#FF4081" [includeSpinner]=false height="4px"></ngx-loading-bar>
<div class="container-fluid">
<router-outlet  #o="outlet"></router-outlet>
</div>
<!-- <router-outlet></router-outlet> -->
